import axios from 'axios';

import { getAPIUrl } from './baseAPI';
import { Country } from '../../types/domainModels';

export const FETCH_AUDIENCE_COUNTRIES = () => ({
  isAdmin: false,
  path: '/countries',
  prefix: 'panelProvider/',
  version: 'v1' as const,
});

export async function fetchAudienceCountries() {
  return (await axios.get<Country[]>(getAPIUrl(FETCH_AUDIENCE_COUNTRIES())))
    .data;
}
